/**
 * @Author:
 * @Description:
 * @DateTime: Created in 22:33 2020/10/9
 */
import _ from 'lodash'
import PublicApi, { QueryDictDetailByCategoryIdsI} from "../util/publicApi";
import {Result} from "../types/base";
import {CommonUtil} from "../util/commonUtil";
import {DictItemDetailI} from "../pages/basicManage/dictManage/api/dictManageApi";

interface DictCashI {
	list: DictItemDetailI[]
	nameToId?: {[str: string]: number}
	idToName?: {[num: number]: string}
}
let promiseCash:{[num:number]: Promise<Result<Array<QueryDictDetailByCategoryIdsI>>>} = {}

let dictCashMap: {[num: number]: DictCashI} = {}
// 每次
let dictCategoryIds:Set<number> = new Set()

export default class DictFactory {

	constructor (dictionaryCategorys: number[]) {
		this.dictionaryCategorys = dictionaryCategorys
	}

	static clearCache() {
		promiseCash = {}
		dictCashMap = {}
		dictCategoryIds = new Set<number>()
	}

	private dictionaryCategorys: number[]


	async initPromise (id: number) {
		if(!promiseCash[id]) {
			// 合并去重
			let idsSet = new Set([...this.dictionaryCategorys,...Array.from(dictCategoryIds)])
			// 将已经缓存的删除
			for (let key in promiseCash) {
				if(idsSet.has(+key)) {
					idsSet.delete(+key)
				}
			}
			let ids = Array.from(idsSet)
			let dictPromise = PublicApi.queryDict({ids: ids.join(',')})
			for (let i = 0, l = ids.length; i < l; i++) {
				let item = ids[i];
				promiseCash[item] = dictPromise
			}
			// 清空
			dictCategoryIds = new Set<number>()
		}

		let {ret, rc} = await promiseCash[id]
		if(dictCashMap[id]) {
			return
		}
		if(rc === 0) {
			_.forEach(ret, (item)=>{
				dictCashMap[item.id] = 	{
					list: item.items
				}
			})
		} else {
			delete dictCashMap[id]
			delete promiseCash[id]
		}
	}

	/**
	 * 获取字典条目
	 * @param {number} dictionaryCategoryId 类别id
	 * @returns {Promise<Array<EnumResI>>}
	 */
	async getDictList (dictionaryCategoryId: number): Promise<Array<{id: number,name: string}>> {
		if(!dictCashMap[dictionaryCategoryId]) {
			dictCategoryIds.add(dictionaryCategoryId)
			await CommonUtil.sleep(0)
			await this.initPromise(dictionaryCategoryId)
		}
		return dictCashMap[dictionaryCategoryId].list
	}

	/**
	 * 获取字典名字
	 * @param {number} dictionaryCategoryId 字典所属类别
	 * @param {number} id	字典id
	 * @returns {Promise<string>}
	 */
	async getNameById (dictionaryCategoryId: number,id: number): Promise<string> {
		if(!dictCashMap[dictionaryCategoryId]) {
			dictCategoryIds.add(dictionaryCategoryId)
			await CommonUtil.sleep(0)
			await this.initPromise(dictionaryCategoryId)
		}
		this.initNameById(dictionaryCategoryId)
		let idToName:any = dictCashMap[dictionaryCategoryId].idToName
		return idToName[id]
	}
	initNameById(dictionaryCategoryId: number) {
		if(!dictCashMap[dictionaryCategoryId].idToName) {
			 let idToName = {}
			_.forEach(dictCashMap[dictionaryCategoryId].list,(item)=>{
				idToName[item.id] = item.name
			})
			dictCashMap[dictionaryCategoryId].idToName = idToName
		}
	}

	/**
	 * 获取字典id
	 * @param {number} dictionaryCategoryId 字典所属类别
	 * @param {string} name	字典name
	 * @returns {Promise<string>}
	 */
	async getIdByName (dictionaryCategoryId: number,name: string): Promise<number> {
		if(!dictCashMap[dictionaryCategoryId]) {
			dictCategoryIds.add(dictionaryCategoryId)
			await CommonUtil.sleep(0)
			await this.initPromise(dictionaryCategoryId)
		}
		this.initIdByName(dictionaryCategoryId)
		let nameToId:any = dictCashMap[dictionaryCategoryId].nameToId
		return nameToId[name]
	}

	initIdByName(dictionaryCategoryId: number) {
		if(!dictCashMap[dictionaryCategoryId].nameToId) {
			let nameToId = {}
			_.forEach(dictCashMap[dictionaryCategoryId].list,(item)=>{
				nameToId[item.name] = item.id
			})
			dictCashMap[dictionaryCategoryId].nameToId = nameToId
		}
	}
}
